import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },

  // Mobile layout - simple sliding between panels
  mobileLayout: {
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
  },

  mobileSlider: {
    display: 'flex',
    width: '200vw',
    height: '100%',
    transition: 'transform 0.3s ease-in-out',
    transform: 'translateX(0)',

    '&.showRight': {
      transform: 'translateX(-100vw)',
    },
  },

  mobilePanel: {
    width: '100vw',
    height: '100%',
    flexShrink: 0,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },

  // Web layout - resizing panels with smooth transitions
  webLayout: {
    height: '100%',
    display: 'flex',
    overflow: 'hidden',
    justifyContent: 'center',
  },

  webLeftPanel: {
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    transition: 'width 0.3s ease-in-out',
    width: '100%',

    '&.split': {
      width: '40%',
    },
  },

  webRightPanel: {
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    transition: 'width 0.3s ease-in-out, opacity 0.3s ease-in-out',
    width: '0%',
    opacity: 0,

    '&.visible': {
      width: '60%',
      opacity: 1,
    },
  },

  // Panel content wrapper
  panelContent: {
    height: '100%',
    width: '100%',
    maxWidth: theme.breakpoints.values.md,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    margin: '0 auto',
  },

  // Legacy styles for backward compatibility
  leftPanel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    minHeight: 0,
  },

  rightPanel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    minHeight: 0,
    width: '100%',
  },

  panelGroup: {
    height: '100%',
    width: '100%',
  },

  rightPanelShown: {
    transform: 'translateX(0)',
    opacity: 1,
    pointerEvents: 'auto',
    transition: 'transform 0.5s ease, opacity 0.5s ease',
    height: '100%',
    width: '100%',
  },

  rightPanelHidden: {
    transform: 'translateX(100%)',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'transform 0.5s ease, opacity 0.5s ease',
    height: '100%',
    width: '100%',
  },

  resizeHandle: {
    width: '2px',
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyItems: 'center',
    position: 'relative',
    cursor: 'col-resize',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: '-2px',
      right: '-2px',
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      transition: 'background-color 0.2s',
    },
    '&:hover::before': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
  },
}));

export default useStyles;
